"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var youtube_player_1 = tslib_1.__importDefault(require("youtube-player"));
var hocs_1 = require("../hocs");
var StyledYoutubeLoader_1 = require("./StyledYoutubeLoader");
var getYoutubeVideoId = function (url) {
    var match = url.match(/.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/);
    if (match === null) {
        return false;
    }
    return match[1];
};
var YoutubeLoaderInner = /** @class */ (function (_super) {
    tslib_1.__extends(YoutubeLoaderInner, _super);
    function YoutubeLoaderInner(props) {
        var _this = _super.call(this, props) || this;
        _this.playerContainer = React.createRef();
        _this.getThumbnailSrc = function () {
            // if content editor has set a thumbnail
            if (_this.props.thumbnail !== undefined) {
                return _this.props.thumbnail;
            }
            // Default to youtube's generated thumbnail
            return "https://img.youtube.com/vi/" + _this.state.videoId + "/maxresdefault.jpg";
        };
        _this.createPlayer = function () {
            _this.player = youtube_player_1.default(_this.playerContainer.current, {
                videoId: _this.state.videoId,
                playerVars: { rel: 0 }
            });
            _this.setState({
                showVideo: true
            }, function () {
                _this.player.playVideo();
            });
        };
        var videoId = getYoutubeVideoId(_this.props.videoUrl);
        if (videoId === false) {
            console.error('An invalid youtube link has been provided.');
        }
        _this.state = {
            videoId: videoId,
            showVideo: false
        };
        return _this;
    }
    YoutubeLoaderInner.prototype.render = function () {
        return (React.createElement(StyledYoutubeLoader_1.VideoContainer, { showVideo: this.state.showVideo, onClick: this.createPlayer },
            React.createElement("img", { src: this.getThumbnailSrc(), alt: "" }),
            React.createElement("div", { ref: this.playerContainer })));
    };
    return YoutubeLoaderInner;
}(React.PureComponent));
/** @component */
exports.YoutubeLoader = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(YoutubeLoaderInner);
//# sourceMappingURL=YoutubeLoader.js.map